module.exports = __webpack_public_path__ + "static/img/stamp.e6d987d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/stamp.png
// module id = qzTV
// module chunks = 1 3